<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="Tp-Author-copy">Dawit Tekie Teclemariam</p>
<p class="Tp-Title-copy">The Long Dark Trail</p>
<div class="_idGenObjectLayout-1">
<div class="Imprint" id="_idContainer000">
<img alt="" class="_idGenObjectAttribute-1" src="image/Logo-for-titlepages-new-bw.png"/>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781528957960_EPUB-2.vue?65e1a43c